import React from "react";
import InventoryCore from "./inventoryCore";
import SuperMarketInventory from "./supermarket";
import useAuthStore from "../../stores/useAuthStore";

const Inventory = () => {
  const tillData = useAuthStore((s) => s.tillData);
  return tillData?.tillAccess ? <InventoryCore component={SuperMarketInventory} /> : <h1>Access Denied</h1>;
};

export default Inventory;
